import { IMilkingForm } from '../types/milkingForm'

export const DEFAULT_MILKING_VALUES: IMilkingForm = {
	am: { halls: [] },
	pm: { halls: [] },
	night: { halls: [] },
	am_allowed_deviation_seconds: '',
	pm_allowed_deviation_seconds: '',
	night_allowed_deviation_seconds: '',
}
